


import React,{useState,useEffect} from "react";
import { DayPicker } from "react-day-picker";
import "react-day-picker/dist/style.css";
import { useParams ,useHistory, useRouteMatch,} from "react-router-dom";
import { useDispatch } from "react-redux";

import HighLightsForCourseAddMore from "./HighLightsForCourseAddMore";
import anim_line from "../../img/winter.png"
import { useSelector } from "react-redux";
import {Minus,Activity ,ChevronLeft,X,Plus ,Phone,Check,Video,MonitorPlay,BookOpenCheck,
    TabletSmartphone,NotebookPen,BookDown,NotepadText,BookA,GalleryHorizontal,BadgePlus} from 'lucide-react';
  
  
const HighLightsForCourse= ({value,closeCourseExpiryType})=>{ 
    const {courseId} = useParams();
  const {url}=useRouteMatch();
  const history = useHistory();
   const dispatch = useDispatch();
   const [snackbarVisible, setSnackbarVisible] = useState(false);
   const [snackbarColor, setSnackbarColor] = useState("#958FDA");
   const [responseMessage, setResponseMessage] =useState("Something Went Wrong!!!");
 
    const showSnackbar = () => {
        setSnackbarVisible(true);
      };
      
       const hideSnackbar = () => {
        setSnackbarVisible(false);
      };
      const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
      {
        
        dispatch({type: "CURSOR",payload:true  });
    
        dispatch({type: "CURSORTEXT",payload:CursorText})
        dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
        dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
      }
       
      const handleMouseLeave = () => {
        
        dispatch({type: "CURSOR",payload:false})
    
        dispatch({type: "CURSORTEXT",payload:""})
    
        dispatch({type: "CURSORTEXTBG",payload:""})
        dispatch({type: "CURSORTEXTCOLOR",payload:""})
      
    
    }
      
      ;
      
     const token = useSelector((state)=>state?.course?.course?.token);
     const currentToken = useSelector((state)=>state?.user?.user?.token);
     const user_email = useSelector((state)=>state?.user?.user?.user_email
    );
    
    const postIdCourse = useSelector((state)=>state?.course?.course?.postId);
    
    const courseData = useSelector((state)=>state?.course?.course);
    
    const AppToken = useSelector((state)=>state?.app?.RecentAppToken);
    
    const [data, setData]= useState({});
    
     const [loader , setLoader] =useState({status:false});
     const [animate, setAnimate] = useState(false);
    
 
 const [itemArr, setItemArr] = useState(courseData?.CourseWhatWillILearn);

     useEffect(() => {
        courseData?.CourseWhatWillILearn.length !== 0?setItemArr(courseData?.CourseWhatWillILearn):
        setItemArr([{ no:1, id: generateTimestamp()
          ,paragraph:"" },]);
          
       // Trigger the animation after a delay (e.g., 500ms)
       const timer = setTimeout(() => {
        setAnimate(true);  
      }, 100);
    
       return () => clearTimeout(timer); // Cleanup on unmount
     }, []);
    
    
   

    function generateTimestamp() {
        return Math.floor(Date.now() / 1000);
      }

      const removeItem = (id) => {
        const filteredItems = itemArr.filter(item => item.id !== id);
        setItemArr(filteredItems);
      };
      const updateItemParagraph = (id, Paragraph) => {
        const updatedItems = itemArr.map(item =>
          item.id === id ? { ...item, paragraph :Paragraph } : item
        
        ); 
        
        setItemArr(updatedItems);
      };
     
    const flattenedData = itemArr!=[]?Object.values(itemArr):'';

  
const [draggedIndex, setDraggedIndex] = useState('');
const [hoveredDropZone, setHoveredDropZone] = useState(null); // Track hovered drop zone

const handleDragStart = (e, index) => {
  
  e.dataTransfer.effectAllowed = 'move';
  e.dataTransfer.setData("dragIndex", index);
  
};

const handleDrop = (e, dropIndex) => {
  const dragIndex = e.dataTransfer.getData("dragIndex");
  if (dragIndex === dropIndex) return;

  const updatedItems = [...itemArr];
  const [draggedItem] = updatedItems.splice(dragIndex, 1);
  updatedItems.splice(dropIndex, 0, draggedItem);

  const reorderedItems = updatedItems.map((item, index) => ({
    ...item,
    id: item.id,
  }));
  setItemArr(reorderedItems);
  setDraggedIndex('');
  setHoveredDropZone(null); // Reset hovered drop zone
};

const handleDragOver = (e, index) => {
  e.preventDefault();
   // Set the hovered drop zone
};

const handleDragEnd = () => {
  setDraggedIndex('');
  setHoveredDropZone(null); // Clear hovered drop zone
};
   
     return(<>
     <div className="selectThumbImgOuterAll"  style={{zIndex:99999} }>
   
  
   <div  className="selectThumbImgOuter " style={{margin:'0px',overflowY: "auto",zIndex:99999}}>
   <div onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave}  style={{width:"40px",height:"40px",cursor:"pointer",
        borderRadius:"50%",right:"10px",margin:"10px",position:"absolute",
      background:"#958FDA",zIndex:99999}} onClick={()=>{closeCourseExpiryType('AddCourseInfoPopUp')}}   >
        <X  style={{padding:"9px",}} color="#fff" size={22}/></div> 
        
        <div className="SetValidityCardOuter CreateCourseStepsOuter" 
        
        style={{marginLeft:"0px",marginRight:"0px",padding:"9px"}}>

       <div align="center" className=""style={{overflow:"hidden",padding:"15px",
        transform: animate ? 'scale(1)' : 'scale(.9)',
        opacity: animate ? 1 : 0,
        transition: 'transform 2s ease, opacity 1s ease',
      }}>

           <Activity size={60}   color="#958FDA" /> 
   

<div class="CreateCourseStepsOuterTitle"> Highlight Important Points About Your Course !!!  </div>
<div class="CreateCourseStepsOuterSubTitle">Add A One Liner Intro In Each Pointer   </div>
<div class="CreateCourseStepsOuterSubTitle"> Explain Key Components About
     Everything That A Student Must Know!!!</div>

</div>
        <div  style={{marginTop:"30px"}}>
    
                                   
    <div className="YoutubeVideoLinkCard" style={{overflowY: "auto",height:"65vh",
        transform: animate ? 'translateY(0)' : 'translateY(-50px)',
        opacity: animate ? 1 : 0,
        transition: 'transform 2s ease, opacity 1s ease',
      }}>
           
{flattenedData?flattenedData.map((item, index) => 
        (<div  index={index} key={item.id} 
          ><div
          className="drop-zone"
          onDragOver={(e) => {setHoveredDropZone(index);
            handleDragOver(e, index)
          }}
          onDrop={(e) => handleDrop(e, index)}
        
          style={{
            height: '15px',position:'relative',left:"0px",right:"0px",
            backgroundColor: hoveredDropZone === index ? 'rgba(149, 143, 218,0.2) ' : 'transparent', // Change color on hover
            border: hoveredDropZone === index ? '2px dashed rgba(149, 143, 218,1) ' : 'transparent', // Change color on hover
            transition: 'background-color  0.3s ease',
            borderRadius: '10px',
           
          }}
        ></div>
            <div
             draggable 
             onDragStart={(e) =>{ handleDragStart(e, index);
              setDraggedIndex(item.id);
             }}
             style={{
              cursor: 'move',
             
              
            }}  className={draggedIndex == item.id?"posFixed":"posRelative"  }
          
              onDragEnd={handleDragEnd}
            ><HighLightsForCourseAddMore index={index} key={item.id} 
        
         paragraph={item.paragraph}  id={item.id} 
           changeItemParagraph={updateItemParagraph } onRemove={removeItem} />
          </div>
          
          </div>)):'' }
    
    <div align="center">
<div align="center"  style={{width:"240px",
     }}> 
      <div onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} className="coloredTextV1" 
     style={{marginTop:"15px",padding:"10px",}}>Add New Pointer</div>
      
      
  <div onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} onClick={()=>setItemArr([...itemArr, {no: itemArr.length, id: generateTimestamp()+2
      ,  paragraph:"" }])}style={{width:"40px",height:"40px",cursor:"pointer",
        borderRadius:"50%",margin:"5px",marginBottom:"20px",
      background:"#958FDA"}} > <Plus  style={{margin:"9px"}}  color="#ffffff" size={22}/></div>
      </div>
    </div>
    </div> 
      
       </div> 
       </div>
       <div className="CreateCourseStepsOuterBottom" style={{padding:'15px',fontSize:'12px',marginBottom:'10px'}}>
    <div  >   </div>
  
    
    <button onMouseEnter={()=>handleMouseEnter("#fd5c63","#fff","")}
     onMouseLeave={handleMouseLeave} onClick={()=>{closeCourseExpiryType('Prerequisite')}}  className="CreateCourseStepsOuterRightButtonBackPopUp"  type="submit"
     id="signupBtn"> Back </button>
 <button onMouseEnter={()=>handleMouseEnter("#fd5c63","#fff","")}
     onMouseLeave={handleMouseLeave} onClick={()=>{closeCourseExpiryType("FAQs")}} style={{width:"140px",height:"55px"}} className="CreateCourseStepsOuterRightButtonPopUp"  type="submit"
     id="signupBtn"> Save And Next </button>
  </div>
    </div>
   
   </div>
   
	                                
     </>)  
   }
   export default HighLightsForCourse;